import { useNuxtApp, useRuntimeConfig } from '#imports'

import type { Bcp47Locale } from '@backmarket/http-api'

import { NUXT_STATE_KEY } from '../constants'
// Side-effect import: brings the `runtimeConfig.public.i18n` augmentation
// into scope for any consumer that imports this composable via the
// subpath export `@backmarket/nuxt-module-i18n/useI18nLocale`. Without
// this, tsc never visits ./types/nuxt and `useRuntimeConfig().public.i18n`
// resolves to `unknown` in downstream packages.
import '../types/nuxt'

/**
 * @returns The current locale used by the translation system.
 *
 * @example
 * const locale = useI18nLocale()
 */
export function useI18nLocale(): Bcp47Locale {
  const nuxtApp = useNuxtApp()
  const { i18n } = useRuntimeConfig().public

  const nuxtLocale: Bcp47Locale = nuxtApp.payload.state[NUXT_STATE_KEY]?.locale

  return nuxtLocale || i18n.fallbackLocale
}
